var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIconFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3H6.75C5.23122 3 4 4.23122 4 5.75V12H20V10H15.75C14.2312 10 13 8.76878 13 7.25V3Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9803 8.49986C19.9072 7.89151 19.6322 7.32145 19.1945 6.88374L16.1161 3.80532C15.6784 3.36761 15.1083 3.09269 14.5 3.01953V7.24986C14.5 7.94022 15.0596 8.49986 15.75 8.49986H19.9803Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.75C3 14.3358 3.33579 14 3.75 14H5.75C6.99264 14 8 15.0074 8 16.25C8 17.4926 6.99264 18.5 5.75 18.5H4.5V20.25C4.5 20.6642 4.16421 21 3.75 21C3.33579 21 3 20.6642 3 20.25V14.75ZM4.5 17H5.75C6.16421 17 6.5 16.6642 6.5 16.25C6.5 15.8358 6.16421 15.5 5.75 15.5H4.5V17Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.75C9 14.3358 9.33579 14 9.75 14H11.25C11.8978 14 12.76 14.1611 13.4802 14.6992C14.2369 15.2646 14.75 16.183 14.75 17.5C14.75 18.817 14.2369 19.7354 13.4802 20.3008C12.76 20.8389 11.8978 21 11.25 21H9.75C9.33579 21 9 20.6642 9 20.25V14.75ZM10.5 15.5V19.5H11.25C11.6856 19.5 12.1984 19.3861 12.5823 19.0992C12.9298 18.8396 13.25 18.383 13.25 17.5C13.25 16.617 12.9298 16.1604 12.5823 15.9008C12.1984 15.6139 11.6856 15.5 11.25 15.5H10.5Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.75C16 14.3358 16.3358 14 16.75 14H20.25C20.6642 14 21 14.3358 21 14.75C21 15.1642 20.6642 15.5 20.25 15.5H17.5V17H19.25C19.6642 17 20 17.3358 20 17.75C20 18.1642 19.6642 18.5 19.25 18.5H17.5V20.25C17.5 20.6642 17.1642 21 16.75 21C16.3358 21 16 20.6642 16 20.25V14.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIconFill);
export default __webpack_public_path__ + "static/media/pdf-icon-fill.6fc54188a9397ceae7407bfa0d9f61d4.svg";
export { ForwardRef as ReactComponent };